import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

export function CodeBlock({ code, language = 'tsx', filename }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try { await navigator.clipboard.writeText(code); }
    catch { const t = document.createElement('textarea'); t.value = code; t.style.position = 'fixed'; t.style.left = '-9999px'; document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t); }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="rounded-lg border border-white/[0.06] overflow-hidden glow-border" data-testid="code-block">
      {/* Header bar */}
      <div className="flex items-center justify-between px-4 py-2.5 bg-[#0A0A0A] border-b border-white/[0.06]">
        <div className="flex items-center gap-3">
          <div className="flex gap-1.5">
            <div className="w-3 h-3 rounded-full bg-white/10" />
            <div className="w-3 h-3 rounded-full bg-white/10" />
            <div className="w-3 h-3 rounded-full bg-white/10" />
          </div>
          {filename && (
            <span className="text-[11px] font-mono text-white/40">{filename}</span>
          )}
          {!filename && language && (
            <span className="text-[11px] font-mono text-white/30 uppercase">{language}</span>
          )}
        </div>
        <button
          onClick={handleCopy}
          className="flex items-center gap-1.5 text-white/30 hover:text-white/60 transition-colors text-xs"
          data-testid="copy-code-btn"
        >
          {copied ? <><Check className="w-3.5 h-3.5 text-emerald-400" /> <span className="text-emerald-400">Copied</span></> : <><Copy className="w-3.5 h-3.5" /> <span>Copy</span></>}
        </button>
      </div>
      {/* Code body */}
      <div className="bg-[#050505] p-4 overflow-x-auto">
        <pre className="text-[13px] leading-6 font-mono text-white/80">
          <code>{code}</code>
        </pre>
      </div>
    </div>
  );
}
